if (!customElements.get('text-columns')) {
  class TextColumns extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mobileLayout !== 'scroll') return;

      this.track = this.querySelector('[data-text-columns-track]');
      this.pagination = this.querySelector('[data-text-columns-pagination]');
      if (!this.track || !this.pagination) return;

      this.slides = Array.from(this.track.querySelectorAll('.text-column'));
      this.dots = Array.from(this.pagination.querySelectorAll('.text-columns__dot'));
      if (!this.slides.length || !this.dots.length) return;

      this._onScroll = () => {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => {
          this._setActive(this._nearestIndex());
          this._ticking = false;
        });
      };

      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      this.dots.forEach((dot) => {
        const goTo = () => {
          const index = Number(dot.getAttribute('data-index')) || 0;
          const slide = this.slides[index];
          if (!slide) return;
          this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          this._setActive(index);
        };

        dot.addEventListener('click', goTo);
        dot.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goTo();
          }
        });
      });
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this._onScroll);
    }

    _setActive(index) {
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    _nearestIndex() {
      const left = this.track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }
  }

  customElements.define('text-columns', TextColumns);
}
